import type { TableColumnType } from 'antd';
import { getProdutoEstoquesParaVenda } from '@/features/produto/util/estoque';
import { numberToString } from '@/std/format';
import type { Produto } from '../../types/Produto';
import type { ProdutoLote } from '../../types/ProdutoLote';
import { ProdutoSelectTable } from './ProdutoSelectTable';
import { getProdutoSelectLotes } from './produtoSelectUtil';

const columns: TableColumnType<ProdutoLote>[] = [
    {
        dataIndex: 'prl_chave',
        title: 'Código do lote',
    },
    {
        dataIndex: 'prl_localizacao',
        title: 'Localização',
    },
    {
        dataIndex: 'prl_data_fabricacao',
        title: 'Data de fabricação',
    },
    {
        dataIndex: 'prl_data_vencimento',
        title: 'Data de vencimento',
    },
];

function getProdutoSelectLoteSaldo(produto: Produto, lote: ProdutoLote): number {
    return getProdutoEstoquesParaVenda(produto, lote).reduce(
        (total, estoque) =>
            total +
            ('ple_estoque_disponivel' in estoque
                ? estoque.ple_estoque_disponivel
                : estoque.pre_estoque_disponivel),
        0,
    );
}

export function ProdutoSelectModalLote({
    produto,
    onSelect,
    onFocusChange,
}: {
    produto: Produto;
    onSelect: (lote: ProdutoLote) => void;
    onFocusChange?: (lote: ProdutoLote | null) => void;
}) {
    return (
        <ProdutoSelectTable
            columns={[
                ...columns,
                {
                    align: 'right',
                    key: 'estoque_disponivel',
                    render: (_, lote) => numberToString(getProdutoSelectLoteSaldo(produto, lote)),
                    title: 'Estoque disponível',
                },
            ]}
            data={getProdutoSelectLotes(produto)}
            emptyText='Nenhum lote cadastrado.'
            onFocusChange={onFocusChange}
            onSelect={onSelect}
            rowKey={(lote) => lote.prl_idpk}
        />
    );
}
